import RevAnalyticsBetaWarning from "../../../../contents/docs/revenue-analytics/_snippets/rev-analytics-beta-warning.mdx";
import * as React from 'react';
export default {
  RevAnalyticsBetaWarning,
  React
};